/* MSP mode global — source de vérité Particulier / Pro.
   Particulier = prix TTC, CTA panier. Pro = prix HT, CTA devis. */
(function () {
  'use strict';
  var KEY = 'msp-mode';
  var VALID = ['particulier', 'pro'];

  function read() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (e) {}
    return VALID.indexOf(v) !== -1 ? v : 'particulier';
  }

  var current = read();

  function getMode() { return current; }

  function setMode(mode) {
    if (VALID.indexOf(mode) === -1 || mode === current) return;
    current = mode;
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    try { document.documentElement.setAttribute('data-msp-mode', mode); } catch (e) {}
    window.dispatchEvent(new CustomEvent('msp:mode-change', { detail: { mode: mode } }));
  }

  try { document.documentElement.setAttribute('data-msp-mode', current); } catch (e) {}

  window.MSP = window.MSP || {};
  window.MSP.getMode = getMode;
  window.MSP.setMode = setMode;
})();
